import ReactPlayer from "react-player";
import "./video-frame.css";

const vFrame = ({ url, title, config }) => {
  return (
    <div className="frame">
      <div className="video">
        <ReactPlayer
          url={url}
          config={config}
          className="player"
          width={"100%"}
          height={"100%"}
        />
      </div>
      <h3>{title}</h3>
    </div>
  );
};

export default vFrame;
